// src/components/app-shell/AppShell.ts
import { LitElement } from 'lit'
import { customElement, state } from 'lit/decorators.js'
import { ChatItem } from '../chat-container'
import { Message, Character } from '../../store'
import { styles } from './styles'
import { AppShellInitializer } from './AppShellInitializer'
import { AppShellHandlers } from './AppShellHandlers'
import { AppShellUI } from './AppShellUI'

@customElement('app-shell')
export class AppShell extends LitElement {
    @state() public _chats: ChatItem[] = []
    @state() public _selectedChatId = ''
    @state() public _messages: Message[] = []
    @state() public _showChatList = true
    @state() public _isMobile = false
    @state() public _characters: Character[] = []

    static styles = styles

    private initializer: AppShellInitializer
    public handlers: AppShellHandlers
    private ui: AppShellUI

    constructor() {
        super()
        this.initializer = new AppShellInitializer(this)
        this.handlers = new AppShellHandlers(this)
        this.ui = new AppShellUI(this)
    }

    connectedCallback() {
        super.connectedCallback()
        this.initializer.initialize()
    }

    disconnectedCallback() {
        super.disconnectedCallback()
        this.initializer.cleanup()
    }

    render() {
        return this.ui.render()
    }
}
